(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('elvn-announce')) {

    customElements.define(
      'elvn-announce',

      class extends HTMLElement {


        connectedCallback() {


          const d = this.dataset;

          const design =
            d.design === 'true';


          const now =
            new Date();


          const pad =
            n => String(n).padStart(2, '0');


          const today =
            now.getFullYear() +
            '-' +
            pad(now.getMonth() + 1) +
            '-' +
            pad(now.getDate());


          /*
           * ====================================================
           * DATE CHECK
           * ====================================================
           *
           * Liquid already filters dates server-side.
           *
           * We check again in the browser because Shopify
           * pages can sometimes be cached.
           */

          this.s = [
            ...this.querySelectorAll('.a11-slide')
          ].filter(
            slide => {

              const from =
                slide.dataset.from;

              const to =
                slide.dataset.to;


              const validFrom =
                !(
                  from.length === 10 &&
                  today < from
                );


              const validTo =
                !(
                  to.length === 10 &&
                  today > to
                );


              const valid =
                design ||
                (
                  validFrom &&
                  validTo
                );


              if (!valid) {

                slide.remove();

              }


              return valid;

            }
          );


          /*
           * ====================================================
           * NOTHING TO SHOW
           * ====================================================
           */

          if (!this.s.length) {

            return this.hide();

          }


          /*
           * ====================================================
           * NUMBER OF SLIDES
           * ====================================================
           */

          if (this.s.length < 2) {

            this.classList.remove(
              'has-many'
            );

          }


          this.i = -1;


          this.go(0);


          this.setHeight();


          /*
           * ====================================================
           * DESKTOP ARROWS
           * ====================================================
           */

          this
            .querySelector('.a11-prev')
            ?.addEventListener(
              'click',
              () => this.go(this.i - 1)
            );


          this
            .querySelector('.a11-next')
            ?.addEventListener(
              'click',
              () => this.go(this.i + 1)
            );


          /*
           * ====================================================
           * PAUSE BEHAVIOUR
           * ====================================================
           */

          this.held = 0;


          const hold =
            on => {

              this.held = on;

            };


          /*
           * Mouse hover
           */

          this.addEventListener(
            'mouseenter',
            () => hold(1)
          );


          this.addEventListener(
            'mouseleave',
            () => hold(0)
          );


          /*
           * Keyboard focus
           */

          this.addEventListener(
            'focusin',
            () => hold(1)
          );


          this.addEventListener(
            'focusout',
            () => hold(0)
          );


          /*
           * Touch
           */

          this.addEventListener(
            'touchstart',
            () => {

              hold(1);

              clearTimeout(
                this.tt
              );

            },
            {
              passive: true
            }
          );


          this.addEventListener(
            'touchend',
            () => {

              this.tt =
                setTimeout(
                  () => hold(0),
                  3000
                );

            },
            {
              passive: true
            }
          );


          /*
           * ====================================================
           * SWIPE
           * ====================================================
           */

          const track =
            this.querySelector(
              '.a11-track'
            );


          if (track) {


            track.addEventListener(
              'pointerdown',
              event => {

                this.x0 =
                  event.clientX;

                this.swiped =
                  false;

              }
            );


            track.addEventListener(
              'pointerup',
              event => {


                if (
                  this.x0 == null
                ) {

                  return;

                }


                const dx =
                  event.clientX -
                  this.x0;


                this.x0 =
                  null;


                if (
                  Math.abs(dx) > 40 &&
                  this.s.length > 1
                ) {


                  this.swiped =
                    true;


                  this.go(
                    this.i +
                    (
                      dx < 0
                        ? 1
                        : -1
                    )
                  );

                }

              }
            );


            track.addEventListener(
              'click',
              event => {


                if (
                  this.swiped
                ) {

                  event.preventDefault();

                  this.swiped =
                    false;

                }

              },
              true
            );

          }


          /*
           * ====================================================
           * AUTO ROTATION
           * ====================================================
           *
           * Never auto rotate when the shopper has enabled
           * prefers-reduced-motion.
           */

          const reducedMotion =
            window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;


          if (
            d.autoplay === 'true' &&
            !reducedMotion &&
            this.s.length > 1
          ) {


            this.timer =
              setInterval(
                () => {


                  if (
                    !this.held &&
                    !document.hidden
                  ) {

                    this.go(
                      this.i + 1
                    );

                  }

                },
                (
                  +d.speed || 4
                ) * 1000
              );

          }


          /*
           * ====================================================
           * SHOPIFY THEME EDITOR
           * ====================================================
           */

          if (design) {


            document.addEventListener(
              'shopify:block:select',
              event => {


                const n =
                  this.s.indexOf(
                    event.target
                  );


                if (n > -1) {

                  this.go(n);

                  hold(1);

                }

              }
            );


            document.addEventListener(
              'shopify:block:deselect',
              () => hold(0)
            );

          }

        }


        /*
         * ======================================================
         * DISCONNECT
         * ======================================================
         */

        disconnectedCallback() {

          clearInterval(
            this.timer
          );

        }


        /*
         * ======================================================
         * GO TO SLIDE
         * ======================================================
         */

        go(n) {


          const len =
            this.s.length;


          n =
            (
              n % len +
              len
            ) % len;


          if (
            n === this.i
          ) {

            return;

          }


          this.s.forEach(
            (slide, index) => {


              const active =
                index === n;


              slide.classList.toggle(
                'is-active',
                active
              );


              slide.toggleAttribute(
                'inert',
                !active
              );


              if (active) {

                slide.removeAttribute(
                  'aria-hidden'
                );

              } else {

                slide.setAttribute(
                  'aria-hidden',
                  'true'
                );

              }


              slide.setAttribute(
                'role',
                'group'
              );


              slide.setAttribute(
                'aria-roledescription',
                'slide'
              );


              slide.setAttribute(
                'aria-label',
                (
                  index + 1
                ) +
                ' of ' +
                len
              );

            }
          );


          /*
           * Diwali colours
           */

          this.classList.toggle(
            'is-diwali',
            this.s[n].dataset.diwali === 'true'
          );


          this.i =
            n;

        }


        /*
         * ======================================================
         * HIDE
         * ======================================================
         */

        hide() {


          this.hidden =
            true;


          clearInterval(
            this.timer
          );


          this.setHeight();

        }


        /*
         * ======================================================
         * UPDATE HEADER HEIGHT VARIABLE
         * ======================================================
         */

        setHeight() {


          document.documentElement.style.setProperty(
            '--m-announcement-height',
            this.hidden
              ? '0px'
              : this.offsetHeight + 'px'
          );

        }

      }
    );

  }


  } catch(e) { console.error(e); }
})();
})();
